<template>
    <div>
        <breadCrumb 
            :icon="'fa-tags'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_voucher`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-if="!addToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New Voucher" @click="addToggle = !addToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add')}}{{$t(`subMenu.my_salon_voucher`)}}</span>
            </button>
        </div>
        <div v-if="!addToggle">
            <ul  class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
                <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.voucherTabLists" :key="t.id">
                    <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
                </li>
            </ul>
                       <div class="panel mt-2 mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 d-block">
                    <VoucherFilter ref="voucherFilter" @search="searchMembers" @filterVoucherItem="filterVoucherItems"></VoucherFilter>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <VoucherList ref="voucherList" :class="{'active': selectedTab == 'active' || selectedTab == 'hidden' }" class="tab-pane"></VoucherList>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="px-3 px-sm-5 py-4">
 
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import VoucherList from './Voucher_List'
import VoucherFilter from './Voucher_Filter'
export default {
    name: 'voucherMenu',
    components:{
        BreadCrumb,
        VoucherList,
        VoucherFilter
    },
    data(){
        let selectedtab = this.$i18n.messages[this.$i18n.locale].tab.voucherTabLists[0].id
        return{
            addToggle: false,
            selectedTab: selectedtab,
            voucherLists: [], outlet:[],
            filterObj:{}
        }
    },
    watch:{
        selectedTab(value){
            console.log(value);
            this.$refs.voucherList.filterVoucherByView(value);           
        },
    },
    methods:{
        filterVoucherItems(filterObj){
            console.log("triggered")
            this.$refs.voucherList.setVoucherItems(filterObj);
        },
        returnVoucherList(){
            this.addToggle = false;
        },
        searchMembers(val){
            this.$refs.voucherList.searchMemberList(val);
        }
    },
}
</script>